<script setup lang="ts">
// Footer for the mega-menu's mobile drawer. The header action bar
// (<HeaderActions>) is `hidden md:flex`, so on mobile the language switcher,
// appearance toggle, and account menu are otherwise unreachable — surface them
// here at the bottom of the drawer, in one action row. Search is not here: on
// mobile it sits in the bar itself, next to the hamburger (TheHeader).
import HeaderAuthMenu from "~/components/header/HeaderAuthMenu.vue";

// Signed in, language and appearance live inside the account menu (same as the
// desktop bar), so the standalone controls would be a second way to do one
// thing. The drawer is touch-only, so the menu's submenus are the single path.

defineProps<{
  locale: string;
  languages: { value: string; label: string }[];
}>();

</script>

<template>
  <div
    class="mt-auto flex items-center gap-2 border-t border-(--color-elevation-200) px-3 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
  >
    <HeaderAuthMenu :locale="locale" :languages="languages" />
  </div>
</template>
